import React from "react";
import { CtaButton } from "./CtaButton";
import { galleryImages } from "../data/content";
export function ProjectGallery() {
  const loop = [...galleryImages, ...galleryImages];
  return <section className="bg-white py-14" aria-labelledby="gallery-title" data-id="element-142" data-mp="1tyo9bd9q9ae7">
      <div className="px-4 text-center" data-id="element-143" data-mp="1twbw1dewzo7h">
        <h2 id="gallery-title" className="font-heading text-2xl font-bold uppercase md:text-3xl" data-id="element-144" data-mp="1yxrdkvhvvcl4">
          Discover our transforming <span className="text-brand" data-id="element-145" data-mp="11b28gcrvwjv1">2-in-1 projects</span>
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-ink-muted" data-id="element-146" data-mp="1680yok8fg6ny">
          Smart furniture that switches roles and adapts to your life. Built by our community.
        </p>
        <div className="mt-6" data-id="element-147" data-mp="1fydfq2h19hpc">
          <CtaButton label="See the collection" data-id="element-148" data-mp="1fzouexc0o9v8" />
        </div>
      </div>
      <div className="mt-10 overflow-hidden" data-id="element-149" data-mp="ijhsqbcuo5z1">
        <div className="animate-marquee flex w-max gap-3" data-id="element-150" data-mp="iiq2zh5xp2go">
          {loop.map((img, i) => <img key={i} src={img.src} alt={i < galleryImages.length ? img.alt : ""} aria-hidden={i >= galleryImages.length} className="h-56 w-48 shrink-0 object-cover md:h-72 md:w-60" data-id="element-151" data-mp="nhawyyulepwo" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}